import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "../lib/cn";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    /** When true, removes background, border, ring, and shadow - for floating content with its own cards (e.g. GHA analytics filter) */
    transparent?: boolean;
  }
>(
  (
    { className, align = "center", sideOffset = 4, transparent, ...props },
    ref,
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 w-72 rounded-md text-neutral-900 outline-hidden dark:text-white",
          !transparent &&
            "border border-[#0c0c0d14] bg-white p-4 shadow-[0px_10px_20px_0px_rgba(0,0,0,0.12)] dark:border-white/12 dark:bg-[#2A2C2C] dark:shadow-[0px_10px_20px_0px_rgba(0,0,0,0.2)]",
          transparent &&
            "w-auto min-w-0 p-0 overflow-visible border-0 bg-transparent shadow-none ring-0 rounded-none",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent };
